__webpack_require__.O(0, ["main"], () => {
	__webpack_require__.E("vendors-node_modules_progress_kendo-react-charts_dist_es_Chart_js-node_modules_progress_kendo-341211");
	__webpack_require__.E("lazyRoutes");
}, 5);